export default __webpack_public_path__ + "static/media/CPD.2b1896c2.jpg";